import moment from "moment";

export function calculateSlotPositions(slotData, rangeFrom, rangeTo) {
  const result = [];
  const range_from = moment(rangeFrom);
  const range_to = moment(rangeTo);

  slotData.forEach((entry) => {
    if (!validateEntry(entry)) return;
    if (range_from.isAfter(entry.checkout_at)) return;

    const renderData = calculateRenderData(entry, range_from, range_to);
    result.push({ entry, renderData });
  });

  return result;
}

function validateEntry(entry) {
  if (!entry?.from) {
    console.warn(entry.id + " -> Dieser Eintrag hat kein Start-Datum!");
    return false;
  }
  if (!entry?.to) {
    console.warn(entry.id + " -> Dieser Eintrag hat kein End-Datum!");
    return false;
  }
  return true;
}

function normalizeToNoon(m) {
  return m.clone().hour(12).minute(0).second(0).millisecond(0);
}

function calculateRenderData(entry, range_from, range_to) {
  const m_from = moment(entry.from);
  const m_to = moment(entry.to);

  const from_noon = normalizeToNoon(m_from);
  const to_noon = normalizeToNoon(m_to);

  let renderData = {
    openStart: false,
    openEnd: false,
    space: exactDiff(from_noon, range_from),
    width: exactDiff(to_noon, from_noon),
    state: entry.state,
  };

  if (m_from.isSame(m_to, "day")) {
    renderData.width = 0.5;
  }

  if (m_to.isAfter(range_to)) {
    renderData.width = exactDiff(range_to, from_noon);
    renderData.openEnd = true;
  }

  if (m_from.isBefore(range_from)) {
    renderData.width = exactDiff(to_noon, range_from);
    renderData.space = 0;
    renderData.openStart = true;

    if (renderData.openEnd) {
      renderData.width = exactDiff(range_to, range_from);
    }
  }

  return renderData;
}

function exactDiff(a, b) {
  const ms = a.diff(b, "milliseconds");
  return ms / (1000 * 60 * 60 * 24);
}
